<template>
  <template-register-page></template-register-page>
</template>

<script lang="ts">

import templateRegisterPage from '@/app-template/lib/pages/RegisterPage.vue';

export default {
  name: "RegisterPage",
  components: { templateRegisterPage },
};
</script>